export default __webpack_public_path__ + "static/media/zeroChargesShield.b21cfb9d.png";